export function isNil(v) {
    return v === null || v === void 0;
}
